import { DEFAULT_PRESET_AMOUNTS } from "./data";

export function formatInr(amount: number): string {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(amount);
}

export function getFundingProgress(raised: number, goal: number): number {
  if (goal <= 0) {
    return 0;
  }
  return Math.min(100, Math.round((raised / goal) * 100));
}

export function getAmountStillNeeded(raised: number, goal: number): number {
  return Math.max(0, goal - raised);
}

export function isCampaignLiveStatus(dateStatus?: string | null): boolean {
  return dateStatus === "live" || dateStatus === "active";
}

export function isCampaignOngoingStatus(dateStatus?: string | null): boolean {
  return (
    isCampaignLiveStatus(dateStatus) || dateStatus === "upcoming" || !dateStatus
  );
}

type ContributionCampaign = {
  amountType?: "fixed" | "variable";
  fixedAmount?: number;
  minContribution?: number;
  maxContribution?: number;
  presetAmounts?: number[];
};

export function getContributionAmounts(
  campaign: ContributionCampaign | null | undefined
): number[] {
  if (campaign?.amountType === "fixed" && campaign.fixedAmount) {
    return [campaign.fixedAmount];
  }

  const presets =
    campaign?.presetAmounts && campaign.presetAmounts.length > 0
      ? campaign.presetAmounts
      : DEFAULT_PRESET_AMOUNTS;

  const min = campaign?.minContribution;
  const max = campaign?.maxContribution;

  const filtered = presets.filter(amount => {
    if (min !== undefined && amount < min) {
      return false;
    }
    if (max !== undefined && amount > max) {
      return false;
    }
    return true;
  });

  if (filtered.length > 0) {
    return filtered;
  }

  if (min !== undefined && (max === undefined || min <= max)) {
    return [min];
  }

  return [DEFAULT_PRESET_AMOUNTS[0]];
}
